<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="isEdit ? '编辑复合团队人员' : '添加复合团队人员'"
      :visible.sync="isShow"
      width="680px"
      :close-on-click-modal="false"
      :before-close="handleBeforeClose"
    >
      <div class="expert-action-wrapper">
        <vue-scroll :ops="ops">
          <el-form
            ref="expertForm"
            class="expert-form"
            :model="formData"
            :rules="formRules"
            label-width="160px"
          >
            <el-form-item label="管理单位" prop="organUuid">
              <el-select
                v-model.trim="formData.organUuid"
                style="width: 100%"
                placeholder="请选择管理单位"
                @change="changeOrg">
                <el-option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机构" prop="youthUuid">
              <el-select
                v-model.trim="formData.youthUuid"
                style="width: 100%"
                placeholder="请选择管理单位后再选择机构"
                @change="changeCenter(formData.youthUuid)">
                <el-option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="idName">
              <el-input
                v-model="formData.idName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item  label="证件类型" class="form_item" style="position: relative" prop="idType">
              <el-select v-model="formData.idType"
                placeholder="请选择证件类型"
                style="width: 100%;" @change="changeType()" :disabled="isEdit ? true : false">
                <el-option
                  v-for="(item, index) in id_types"
                  :key="index"
                  :label="item.key"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  label="人员类型" class="form_item" style="position: relative" prop="coachTypeEnum">
              <el-select v-model="formData.coachTypeEnum"
                placeholder="请选择人员类型"
                style="width: 100%;" @change="changeType()" :disabled="isEdit ? true : false">
                <el-option label="体能教练员" value="PHYSICALCOACH"> </el-option>
                <el-option label="运动康复师" value="REHABILITATION"> </el-option>
                <el-option label="队医" value="TEAMDOCTOR"> </el-option>
                <el-option label="其他（技术分析师）" value="OTHER"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别" v-if="formData.idType!=='IDNUMBER'" prop="gender">
              <!-- prop="coachNature" -->
              <el-radio-group v-model="formData.gender" >
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                v-model="formData.idNumber"
                placeholder="请输入身份证号"
                :disabled="isEdit ? true : false"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="formData.phone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="工作类型" >
              <!-- prop="coachNature" -->
              <el-radio-group v-model="formData.coachNature">
                <el-radio label="全职">全职</el-radio>
                <el-radio label="兼职">兼职</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="复合团队工作合同" >
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemoveFileContract"
                :before-upload="beforeUpload"
                :on-success="handleSuccessFilerContract"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="uploadFileListContract"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <a style="color: #666;">单个上传文件大小不能超过50M,最多上传1个文件。</a>
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="复合团队社保证明" v-if="formData.coachNature === '全职'">
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemoveFileSecurity"
                :before-upload="beforeUpload"
                :on-success="handleSuccessFilerSecurity"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="uploadFileListSecurity"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <a style="color: #666;">单个上传文件大小不能超过50M,最多上传1个文件。</a>
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="相关资质文件" :error="uploadErroeMsg" >
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemoveFile"
                :before-upload="beforeUpload"
                :on-success="handleSuccessFiler"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="uploadFileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <a style="color: #666;">单个上传文件大小不能超过50M,最多上传1个文件。</a>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </vue-scroll>
      </div>
      <div class="tip" v-if="!isEdit">
        * 体能教练员需要满足2026年在市足协注册的体能教练员
      </div>
      <div slot="footer" class="footer-btns-big">
        <el-button
          type="primary"
          @click="handleDialogAction('confirm')"
          :loading="actionLoading"
          >确 定</el-button
        >
        <el-button type="danger" @click="handleDialogAction('cancel')"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { filterIdNumber } from "@/utils/yioks_filter";
import { isIdNumber } from "@/assets/js/formRules"
import coach from '@/api/coach'
import yioksRules from "@/utils/formRules/rules";
import auth from "@/api/auth";
import JSEncrypt from "@/assets/js/jsencrypt.min.js";
import storage from '@/utils/storage'
import {  id_types } from '@/utils/yioks_data'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    defaultInfo: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      ops,
      formData: {
        idName: "",
        idNumber: "",
        organUuid: "",
        youthUuid: "",
        gender: "",
        youthShortName: "",
        organShortName: "",
        idType: 'IDNUMBER',
        fileUrl: "",
        fileName: "",
        coachTypeEnum: "",
        phone: "",
        coachNature: "",

      },
      id_types: id_types,
      userRole: storage.get('userInfo').userRole,
      selectOrganList: [],
      selectCenterList: [],
      actionLoading: false,
      id_numberMsg: '请输入身份证号',
      editUuid: "",
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      uploadFileListContract: [],
      uploadFileListSecurity: [],
    };
  },

  computed: {
    formRules() {
      if (this.isEdit) {
        return {
          idName: [requiredItem("姓名")],
          idNumber: [requiredItem("身份证号")],
          idType: [requiredItem("证件类型")],
          phone: [requiredItem("手机号")],
          gender: [requiredItem("性别")],
          coachTypeEnum: [requiredItem("人员类型")],
        };
      } else {
        return {
          idName: [requiredItem("姓名")],
          idNumber: [requiredItem("身份证号"), isIdNumber()],
          idType: [requiredItem("证件类型")],
          phone: [requiredItem("手机号")],
          gender: [requiredItem("性别")],
          coachTypeEnum: [requiredItem("人员类型")],
        };
      }
    },
  },

  created() {
    this.getOrganListAndCenterList();
    if (this.isEdit) {

      this.formData = Object.assign({}, this.formData, {
        ...this.defaultInfo
      });
      if(this.formData.fileUrl){
        const fileObj = {
          name: this.formData.fileName,
          url: this.formData.fileUrl,
          fileName: this.formData.fileName,
          fileUrl: this.formData.fileUrl
        };
        this.uploadFileList.push(fileObj);
      }
      if(this.formData.fileUrlContract){
        const fileObj = {
          name: this.formData.fileNameContract,
          url: this.formData.fileUrlContract,
          fileName: this.formData.fileNameContract,
          fileUrl: this.formData.fileUrlContract
        };
        this.uploadFileListContract.push(fileObj);
      }
      if(this.formData.fileUrlSecurity){
        const fileObj = {
          name: this.formData.fileNameSecurity,
          url: this.formData.fileUrlSecurity,
          fileName: this.formData.fileNameSecurity,
          fileUrl: this.formData.fileUrlSecurity
        };
        this.uploadFileListSecurity.push(fileObj);
      }
      this.editUuid = this.defaultInfo.uuid;
    }
  },

  methods: {
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.selectOrganList = res
        if (this.selectOrganList.length === 1) {
          this.formData.organUuid = this.selectOrganList[0].organUuid
          this.formData.organShortName = this.selectOrganList[0].organShortName
          this.selectCenterList = this.selectOrganList[0].youthList || []
          if (this.selectCenterList.length === 1) {
            this.formData.youthUuid = this.selectCenterList[0].uuid
            this.formData.youthShortName = this.selectCenterList[0].youthShortName
          }
        }
        if(this.isEdit){
          if (this.formData.organUuid) {
            this.formData.organShortName = this.selectOrganList.find(item => {
              return item.organUuid === this.formData.organUuid
            }).organShortName
            this.selectCenterList = this.selectOrganList.find(item => {
              return item.organUuid === this.formData.organUuid
            }).youthList || []
            if (this.selectCenterList.length === 1) {
              this.formData.youthUuid = this.selectCenterList[0].uuid
              this.formData.youthShortName = this.selectCenterList[0].youthShortName
            }
            this.formData.youthShortName = this.selectCenterList.find(item => {
              return item.uuid === this.formData.youthUuid
            }).youthShortName
          } else {
            this.selectCenterList = []
          }
        }
      })
    },
    changeOrg () {
      this.$set(this.formData, 'youthUuid', '')
      this.$set(this.formData, 'youthShortName', '')
      if (this.formData.organUuid) {
        this.formData.organShortName = this.selectOrganList.find(item => {
          return item.organUuid === this.formData.organUuid
        }).organShortName
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.formData.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.formData.youthUuid = this.selectCenterList[0].uuid
          this.formData.youthShortName = this.selectCenterList[0].youthShortName
        }
      } else {
        this.selectCenterList = []
      }
    },
    changeCenter (youthUuid) {
      this.formData.youthShortName = this.selectCenterList.find(item => {
        return item.uuid === this.formData.youthUuid
      }).youthShortName
    },
    handleRemoveFileContract(file, fileList) {
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileListContract = this.uploadFileListContract.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileListContract = this.uploadFileListContract.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    //  证明材料提交成功
    handleSuccessFilerContract(res, file) {
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.uploadFileListContract.push(fileObj);
    },
    handleRemoveFileSecurity(file, fileList) {
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileListSecurity = this.uploadFileListSecurity.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileListSecurity = this.uploadFileListSecurity.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    //  证明材料提交成功
    handleSuccessFilerSecurity(res, file) {
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.uploadFileListSecurity.push(fileObj);
    },

    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
//      if(this.isEdit) {
//        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
//          const  status = file.url !== item.url;
//          return status
//        })
//      }
    },
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传1个文件，请删除后再次上传。`);
    },
    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
//      if (this.isEdit) {
//        this.uploadFileList_edit.push(fileObj);
//      }
      this.uploadFileList.push(fileObj);
    },
    // 上传文件检测
    beforeUpload(file) {
      const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc|zip|rar)$/i
      const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
        return false;
      }
      if (!fileType) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc zip rar格式的文件");
        return false;
      }
      return fileLimit;
    },
    handleBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    async handleDialogAction(flag) {
      if (flag == "confirm") {
        if(this.uploadFileListContract.length === 0){
          this.$message.error("请检查工作合同是否上传。");
          return
        }
        if(this.uploadFileListSecurity.length === 0 && this.formData.coachNature === '全职'){
          this.$message.error("请检查社保证明是否上传。");
          return
        }
        // this.$emit("callback", true, true);
        this.actionLoading = true;
        this.$refs["expertForm"].validate(async (valid) => {
          if (valid) {
            const {     ...rest } = this.formData;

            let postData = {
              ...rest,
              fileUrl: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileUrl : "",
              fileName: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileName : "",
              fileUrlContract: this.uploadFileListContract.length > 0 ? this.uploadFileListContract[0].fileUrl : "",
              fileNameContract: this.uploadFileListContract.length > 0 ? this.uploadFileListContract[0].fileName : "",
              fileUrlSecurity: (this.uploadFileListSecurity.length > 0 && this.formData.coachNature=== '全职') ? this.uploadFileListSecurity[0].fileUrl : "",
              fileNameSecurity: (this.uploadFileListSecurity.length > 0 && this.formData.coachNature === '全职') ? this.uploadFileListSecurity[0].fileName : "",
              workName: this.formData.organShortName+'-'+this.formData.youthShortName,
            };
            let requestName = coach.addcoachTeamAdd;
            if (this.isEdit) {
              requestName = coach.addcoachTeamEdit;
            }

            requestName(postData)
              .then((res) => {
                this.actionLoading = false;
                if (res.code) {
                  this.$message.error(res.msg);
                  return;
                }
                this.$emit("callback", true, true);
              })
              .catch((err) => {
                this.actionLoading = false;
                console.error("err", err);
                this.$emit("callback", true, false);
              });
          } else {
            this.actionLoading = false;
          }
        });
      } else if (flag == "cancel") {
        this.$emit("callback", false, true);
      }
    },
    changeType () {
      switch (this.formData.idType) {
        case 'IDNUMBER': // 身份证
          this.formData.idCountry = 'CN'
          this.id_numberMsg = '请输入身份证号'
          break
        case 'IDTYPECODEWGJZZ': // 外国人永久居留身份证
          this.formData.idCountry = 'CN'
          this.id_numberMsg = '例如：CAN000000000000'
          break
        case 'IDTYPECODEHMT': // 港澳台居民居住证
          this.formData.idCountry = 'CN'
          this.id_numberMsg = '请输入港澳台居民居住证号'
          break
        case 'HM': // 港澳居民来往内地通行证
          this.formData.idCountry = 'CN'
          this.id_numberMsg = '例如：H00000000'
          break
        case 'TAI': // 台湾居民来往大陆通行证
          this.formData.idCountry = 'CN'
          this.id_numberMsg = '例如：00000000'
          break
        case 'PASSPORT': // 护照（非中国大陆人员）
          this.formData.idCountry = ''
          this.id_numberMsg = '例如：E00000000'
          break
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.expert-action-wrapper
  height 480px
.expert-form
  margin-right 160px
</style>
